module.exports = __webpack_public_path__ + "media/images/trash_icon-5858f8253aebe80e72b67a7833aca7cc.svg";